import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  description:
    'Search for the Business or Person that this transaction relates to. This will link already existing and future transactions to this Contact. ',
  successMessage: 'Contact linked successfully',
})
